import { Variants } from '@amplitude/experiment-js-client';

const TRUTHY_VALUES = new Set(['on', 'treatment']);

export const variantsToFeatureFlags = (variants: Variants): Record<string, boolean> =>
    Object.fromEntries(
        Object.entries(variants).map(([key, variant]) => [key, TRUTHY_VALUES.has(variant?.value ?? '')])
    );
